export default __webpack_public_path__ + "static/media/7.bc57ff33.jpeg";